<template>
	<div class='forgot_wrap'>
		<div class="table_container">
			<h1>It’s done!</h1>
			<p class='notice'>You have reset your password.</p>
			<a class="sign_in_ag" @click="next_reset">Sign in again</a>
		</div>
	</div>
</template>

<script>
import { urls } from '@js'

export default {
  data() {
    return {
      user_email: ''
    }
  },
  methods: {
    next_reset: function() {
      window.localStorage.removeItem('r_email') // 移除r_email
      window.location.href = urls.ssoLogin
    }
  }
}
</script>

<style lang='less' scoped>
.forgot_wrap {
  height: 1000px;
  background: url('~@img/creat_acount_bg.jpg') no-repeat center
    center;
  .table_container {
    width: 366px;
    margin: 0 auto;
    padding-top: 255px;
    h1 {
      text-align: center;
      color: #46c180;
      font-size: 37.3px;
      font-weight: normal;
    }
    p {
      padding-top: 15px;
      font-size: 24px;
      color: #ffffff;
    }
    a.sign_in_ag {
      display: inline-block;
      cursor: pointer;
      margin-top: 54px;
      width: 100%;
      height: 46px;
      line-height: 46px;
      font-size: 24px;
      text-align: center;
      border-radius: 50px;
      background: #ffc000;
      color: #000000;
    }
  }
}
</style>


// WEBPACK FOOTER //
// forgot_password_step4.vue?27a47e6b